import { useMemo } from "react";
import { InputFieldProps } from "./types";
import { ObjectInput } from "./ObjectInput";

export const ArrayInput: React.FC<InputFieldProps> = ({ objectInput, inputField, inputValue, path, onUpdate, validationErrors }) => {
	if (inputField.type !== "array") {
		return <>non-array input field types is not currently supported</>;
	}

	const handleArrayAdd = () => {
		const newArray = Array.isArray(inputValue) ? [...inputValue, {}] : [{}];

		onUpdate?.(newArray);
	};

	const handleArrayRemove = (index: number) => {
		const newArray = Array.isArray(inputValue) ? [...inputValue] : [];
		newArray.splice(index, 1);
		onUpdate?.(newArray);
	};

	const handleArrayItemChange = (index: number, newValue: any) => {
		const newArray = Array.isArray(inputValue) ? [...inputValue] : [];
		newArray[index] = newValue;

		onUpdate?.(newArray);
	};

	const arrayValues = Array.isArray(inputValue) ? inputValue : [];

	const addItemLabel = useMemo(
		() =>
			`Add ${inputField.name
				.replace(/([A-Z])/g, " $1")
				.replace(/^./, (s) => s.toUpperCase())
				.trim()
				.replace(/s$/, "")}`,
		[inputField.name],
	);

	return (
		<div className="space-y-2 ">
			{arrayValues.map((itemValue, arrayValueIndex) => (
				<div key={arrayValueIndex} className="border border-gray-200 rounded-lg">
					<div className="bg-gray-50 px-4 py-3 border-b border-gray-200 flex justify-between items-center">
						<h3 className="text-sm font-medium text-gray-700">Item #{arrayValueIndex + 1}</h3>
						<button
							onClick={() => handleArrayRemove(arrayValueIndex)}
							className="p-1.5 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors"
							title="Delete Item"
						>
							<img src={`/assets/ui/trash-01.svg`} alt="Delete" className="w-4 h-4 filter brightness-0 invert" />
						</button>
					</div>
					<div className="p-4">
						<ObjectInput
							objectInput={objectInput}
							inputField={{ ...inputField, type: "object", properties: inputField.items }}
							inputValue={itemValue}
							path={`${path}[${arrayValueIndex}]`}
							onUpdate={(update) => handleArrayItemChange(arrayValueIndex, update)}
							validationErrors={validationErrors}
						/>
					</div>
				</div>
			))}
			<div className="flex items-center justify-end">
				<button onClick={handleArrayAdd} className="text-md bg-blue-600 hover:bg-green-600 text-gray-100 px-2 py-1 rounded">
					{addItemLabel}
				</button>
			</div>
		</div>
	);
};
